/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Cabin,
  CompactCruise,
  CompactCruiseSortBy,
  Cruise,
  DictionaryItem,
  DictionaryType,
  Direction,
  ErrorMessage,
  Flight,
  Gateway,
  OrderDirection,
  RailTransport,
  RailTransportType,
} from '../models/index';
import {
    CabinFromJSON,
    CabinToJSON,
    CompactCruiseFromJSON,
    CompactCruiseToJSON,
    CompactCruiseSortByFromJSON,
    CompactCruiseSortByToJSON,
    CruiseFromJSON,
    CruiseToJSON,
    DictionaryItemFromJSON,
    DictionaryItemToJSON,
    DictionaryTypeFromJSON,
    DictionaryTypeToJSON,
    DirectionFromJSON,
    DirectionToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    FlightFromJSON,
    FlightToJSON,
    GatewayFromJSON,
    GatewayToJSON,
    OrderDirectionFromJSON,
    OrderDirectionToJSON,
    RailTransportFromJSON,
    RailTransportToJSON,
    RailTransportTypeFromJSON,
    RailTransportTypeToJSON,
} from '../models/index';

export interface FindCabinsRequest {
    cruiseId: string;
    cabinCategoryCode: string;
    agencyId: number;
    priceModelCode: string;
    adults: number;
    juveniles: number;
    children: number;
    xTrackingIdentifier?: string;
    babies?: number;
    displayAccessibleCabins?: boolean;
}

export interface FindCruisesRequest {
    agencyId: number;
    xTrackingIdentifier?: string;
    earliestDepartureDate?: string;
    latestArrivalDate?: string;
    priceModelCodes?: Array<string>;
    minDuration?: number;
    maxDuration?: number;
    regions?: Array<string>;
    departurePorts?: Array<string>;
    ports?: Array<string>;
    arrivalPorts?: Array<string>;
    gateways?: Array<string>;
    higherFlightClasses?: boolean;
    cabinCategoryGroups?: Array<string>;
    cruiseAttributes?: Array<string>;
    campaigns?: Array<string>;
    ships?: Array<string>;
    adults?: number;
    juniors?: number;
    children?: number;
    babies?: number;
    flexFlight?: boolean;
    pageSize?: number;
    pageNumber?: number;
    sortBy?: CompactCruiseSortBy;
    sortByAddition?: string;
    order?: OrderDirection;
}

export interface FindDictionaryItemsRequest {
    type: DictionaryType;
    xTrackingIdentifier?: string;
}

export interface FindFlexFlightsRequest {
    cruiseId: string;
    agencyId: number;
    priceModelCode: string;
    birthdays: Array<string>;
    gateway: string;
    nonstop: boolean;
    flightClassCode: string;
    xTrackingIdentifier?: string;
    maxStops?: number;
    carrierCodes?: Array<string>;
    direction?: Direction;
}

export interface FindFlightsRequest {
    cruiseId: string;
    agencyId: number;
    priceModelCode: string;
    adults: number;
    juveniles: number;
    children: number;
    xTrackingIdentifier?: string;
    babies?: number;
}

export interface FindGatewaysRequest {
    cruiseId: string;
    agencyId: number;
    priceModelCode: string;
    xTrackingIdentifier?: string;
}

export interface FindRailTransportsRequest {
    cruiseId: string;
    agencyId: number;
    priceModelCode: string;
    ages: Array<number>;
    type: RailTransportType;
    xTrackingIdentifier?: string;
    gateway?: string;
    direction?: Direction;
}

export interface GetCabinRequest {
    cruiseId: string;
    cabinNumber: number;
    agencyId: number;
    priceModelCode: string;
    adults: number;
    juveniles: number;
    children: number;
    xTrackingIdentifier?: string;
    babies?: number;
}

export interface GetCruiseRequest {
    cruiseId: string;
    agencyId: number;
    priceModelCode: string;
    adults: number;
    juveniles: number;
    children: number;
    xTrackingIdentifier?: string;
    babies?: number;
}

/**
 * 
 */
export class ExpitecApi extends runtime.BaseAPI {

    /**
     * Retrieves available cabins regarding given cruise
     */
    async findCabinsRaw(requestParameters: FindCabinsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Cabin>>> {
        if (requestParameters['cruiseId'] == null) {
            throw new runtime.RequiredError(
                'cruiseId',
                'Required parameter "cruiseId" was null or undefined when calling findCabins().'
            );
        }

        if (requestParameters['cabinCategoryCode'] == null) {
            throw new runtime.RequiredError(
                'cabinCategoryCode',
                'Required parameter "cabinCategoryCode" was null or undefined when calling findCabins().'
            );
        }

        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling findCabins().'
            );
        }

        if (requestParameters['priceModelCode'] == null) {
            throw new runtime.RequiredError(
                'priceModelCode',
                'Required parameter "priceModelCode" was null or undefined when calling findCabins().'
            );
        }

        if (requestParameters['adults'] == null) {
            throw new runtime.RequiredError(
                'adults',
                'Required parameter "adults" was null or undefined when calling findCabins().'
            );
        }

        if (requestParameters['juveniles'] == null) {
            throw new runtime.RequiredError(
                'juveniles',
                'Required parameter "juveniles" was null or undefined when calling findCabins().'
            );
        }

        if (requestParameters['children'] == null) {
            throw new runtime.RequiredError(
                'children',
                'Required parameter "children" was null or undefined when calling findCabins().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['agencyId'] != null) {
            queryParameters['agencyId'] = requestParameters['agencyId'];
        }

        if (requestParameters['priceModelCode'] != null) {
            queryParameters['priceModelCode'] = requestParameters['priceModelCode'];
        }

        if (requestParameters['adults'] != null) {
            queryParameters['adults'] = requestParameters['adults'];
        }

        if (requestParameters['juveniles'] != null) {
            queryParameters['juveniles'] = requestParameters['juveniles'];
        }

        if (requestParameters['children'] != null) {
            queryParameters['children'] = requestParameters['children'];
        }

        if (requestParameters['babies'] != null) {
            queryParameters['babies'] = requestParameters['babies'];
        }

        if (requestParameters['displayAccessibleCabins'] != null) {
            queryParameters['displayAccessibleCabins'] = requestParameters['displayAccessibleCabins'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTrackingIdentifier'] != null) {
            headerParameters['X-Tracking-Identifier'] = String(requestParameters['xTrackingIdentifier']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/cruises/{cruiseId}/categories/{cabinCategoryCode}/cabins`.replace(`{${"cruiseId"}}`, encodeURIComponent(String(requestParameters['cruiseId']))).replace(`{${"cabinCategoryCode"}}`, encodeURIComponent(String(requestParameters['cabinCategoryCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CabinFromJSON));
    }

    /**
     * Retrieves available cabins regarding given cruise
     */
    async findCabins(requestParameters: FindCabinsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Cabin>> {
        const response = await this.findCabinsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for cruises, returns cruises and offers in a compact format The minimum request must contain one of the parameters adults, juniors, children, babies 
     * Search for cruises
     */
    async findCruisesRaw(requestParameters: FindCruisesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompactCruise>>> {
        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling findCruises().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['agencyId'] != null) {
            queryParameters['agencyId'] = requestParameters['agencyId'];
        }

        if (requestParameters['earliestDepartureDate'] != null) {
            queryParameters['earliestDepartureDate'] = requestParameters['earliestDepartureDate'];
        }

        if (requestParameters['latestArrivalDate'] != null) {
            queryParameters['latestArrivalDate'] = requestParameters['latestArrivalDate'];
        }

        if (requestParameters['priceModelCodes'] != null) {
            queryParameters['priceModelCodes'] = requestParameters['priceModelCodes'];
        }

        if (requestParameters['minDuration'] != null) {
            queryParameters['minDuration'] = requestParameters['minDuration'];
        }

        if (requestParameters['maxDuration'] != null) {
            queryParameters['maxDuration'] = requestParameters['maxDuration'];
        }

        if (requestParameters['regions'] != null) {
            queryParameters['regions'] = requestParameters['regions'];
        }

        if (requestParameters['departurePorts'] != null) {
            queryParameters['departurePorts'] = requestParameters['departurePorts'];
        }

        if (requestParameters['ports'] != null) {
            queryParameters['ports'] = requestParameters['ports'];
        }

        if (requestParameters['arrivalPorts'] != null) {
            queryParameters['arrivalPorts'] = requestParameters['arrivalPorts'];
        }

        if (requestParameters['gateways'] != null) {
            queryParameters['gateways'] = requestParameters['gateways'];
        }

        if (requestParameters['higherFlightClasses'] != null) {
            queryParameters['higherFlightClasses'] = requestParameters['higherFlightClasses'];
        }

        if (requestParameters['cabinCategoryGroups'] != null) {
            queryParameters['cabin-category-groups'] = requestParameters['cabinCategoryGroups'];
        }

        if (requestParameters['cruiseAttributes'] != null) {
            queryParameters['cruise-attributes'] = requestParameters['cruiseAttributes'];
        }

        if (requestParameters['campaigns'] != null) {
            queryParameters['campaigns'] = requestParameters['campaigns'];
        }

        if (requestParameters['ships'] != null) {
            queryParameters['ships'] = requestParameters['ships'];
        }

        if (requestParameters['adults'] != null) {
            queryParameters['adults'] = requestParameters['adults'];
        }

        if (requestParameters['juniors'] != null) {
            queryParameters['juniors'] = requestParameters['juniors'];
        }

        if (requestParameters['children'] != null) {
            queryParameters['children'] = requestParameters['children'];
        }

        if (requestParameters['babies'] != null) {
            queryParameters['babies'] = requestParameters['babies'];
        }

        if (requestParameters['flexFlight'] != null) {
            queryParameters['flexFlight'] = requestParameters['flexFlight'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['pageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortByAddition'] != null) {
            queryParameters['sortByAddition'] = requestParameters['sortByAddition'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTrackingIdentifier'] != null) {
            headerParameters['X-Tracking-Identifier'] = String(requestParameters['xTrackingIdentifier']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/compact-cruises`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompactCruiseFromJSON));
    }

    /**
     * Search for cruises, returns cruises and offers in a compact format The minimum request must contain one of the parameters adults, juniors, children, babies 
     * Search for cruises
     */
    async findCruises(requestParameters: FindCruisesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompactCruise>> {
        const response = await this.findCruisesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of dictionary items.
     */
    async findDictionaryItemsRaw(requestParameters: FindDictionaryItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DictionaryItem>>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling findDictionaryItems().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTrackingIdentifier'] != null) {
            headerParameters['X-Tracking-Identifier'] = String(requestParameters['xTrackingIdentifier']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/dictionaries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DictionaryItemFromJSON));
    }

    /**
     * Returns a list of dictionary items.
     */
    async findDictionaryItems(requestParameters: FindDictionaryItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DictionaryItem>> {
        const response = await this.findDictionaryItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves available flex flights regarding given cruise
     */
    async findFlexFlightsRaw(requestParameters: FindFlexFlightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Flight>>> {
        if (requestParameters['cruiseId'] == null) {
            throw new runtime.RequiredError(
                'cruiseId',
                'Required parameter "cruiseId" was null or undefined when calling findFlexFlights().'
            );
        }

        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling findFlexFlights().'
            );
        }

        if (requestParameters['priceModelCode'] == null) {
            throw new runtime.RequiredError(
                'priceModelCode',
                'Required parameter "priceModelCode" was null or undefined when calling findFlexFlights().'
            );
        }

        if (requestParameters['birthdays'] == null) {
            throw new runtime.RequiredError(
                'birthdays',
                'Required parameter "birthdays" was null or undefined when calling findFlexFlights().'
            );
        }

        if (requestParameters['gateway'] == null) {
            throw new runtime.RequiredError(
                'gateway',
                'Required parameter "gateway" was null or undefined when calling findFlexFlights().'
            );
        }

        if (requestParameters['nonstop'] == null) {
            throw new runtime.RequiredError(
                'nonstop',
                'Required parameter "nonstop" was null or undefined when calling findFlexFlights().'
            );
        }

        if (requestParameters['flightClassCode'] == null) {
            throw new runtime.RequiredError(
                'flightClassCode',
                'Required parameter "flightClassCode" was null or undefined when calling findFlexFlights().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['agencyId'] != null) {
            queryParameters['agencyId'] = requestParameters['agencyId'];
        }

        if (requestParameters['priceModelCode'] != null) {
            queryParameters['priceModelCode'] = requestParameters['priceModelCode'];
        }

        if (requestParameters['birthdays'] != null) {
            queryParameters['birthdays'] = requestParameters['birthdays'];
        }

        if (requestParameters['gateway'] != null) {
            queryParameters['gateway'] = requestParameters['gateway'];
        }

        if (requestParameters['nonstop'] != null) {
            queryParameters['nonstop'] = requestParameters['nonstop'];
        }

        if (requestParameters['flightClassCode'] != null) {
            queryParameters['flightClassCode'] = requestParameters['flightClassCode'];
        }

        if (requestParameters['maxStops'] != null) {
            queryParameters['maxStops'] = requestParameters['maxStops'];
        }

        if (requestParameters['carrierCodes'] != null) {
            queryParameters['carrierCodes'] = requestParameters['carrierCodes'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTrackingIdentifier'] != null) {
            headerParameters['X-Tracking-Identifier'] = String(requestParameters['xTrackingIdentifier']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/cruises/{cruiseId}/flexflights`.replace(`{${"cruiseId"}}`, encodeURIComponent(String(requestParameters['cruiseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FlightFromJSON));
    }

    /**
     * Retrieves available flex flights regarding given cruise
     */
    async findFlexFlights(requestParameters: FindFlexFlightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Flight>> {
        const response = await this.findFlexFlightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves available flights regarding given cruise
     */
    async findFlightsRaw(requestParameters: FindFlightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Flight>>> {
        if (requestParameters['cruiseId'] == null) {
            throw new runtime.RequiredError(
                'cruiseId',
                'Required parameter "cruiseId" was null or undefined when calling findFlights().'
            );
        }

        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling findFlights().'
            );
        }

        if (requestParameters['priceModelCode'] == null) {
            throw new runtime.RequiredError(
                'priceModelCode',
                'Required parameter "priceModelCode" was null or undefined when calling findFlights().'
            );
        }

        if (requestParameters['adults'] == null) {
            throw new runtime.RequiredError(
                'adults',
                'Required parameter "adults" was null or undefined when calling findFlights().'
            );
        }

        if (requestParameters['juveniles'] == null) {
            throw new runtime.RequiredError(
                'juveniles',
                'Required parameter "juveniles" was null or undefined when calling findFlights().'
            );
        }

        if (requestParameters['children'] == null) {
            throw new runtime.RequiredError(
                'children',
                'Required parameter "children" was null or undefined when calling findFlights().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['agencyId'] != null) {
            queryParameters['agencyId'] = requestParameters['agencyId'];
        }

        if (requestParameters['priceModelCode'] != null) {
            queryParameters['priceModelCode'] = requestParameters['priceModelCode'];
        }

        if (requestParameters['adults'] != null) {
            queryParameters['adults'] = requestParameters['adults'];
        }

        if (requestParameters['juveniles'] != null) {
            queryParameters['juveniles'] = requestParameters['juveniles'];
        }

        if (requestParameters['children'] != null) {
            queryParameters['children'] = requestParameters['children'];
        }

        if (requestParameters['babies'] != null) {
            queryParameters['babies'] = requestParameters['babies'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTrackingIdentifier'] != null) {
            headerParameters['X-Tracking-Identifier'] = String(requestParameters['xTrackingIdentifier']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/cruises/{cruiseId}/flights`.replace(`{${"cruiseId"}}`, encodeURIComponent(String(requestParameters['cruiseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FlightFromJSON));
    }

    /**
     * Retrieves available flights regarding given cruise
     */
    async findFlights(requestParameters: FindFlightsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Flight>> {
        const response = await this.findFlightsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves available gateways for flex flights regarding given cruise
     */
    async findGatewaysRaw(requestParameters: FindGatewaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Gateway>>> {
        if (requestParameters['cruiseId'] == null) {
            throw new runtime.RequiredError(
                'cruiseId',
                'Required parameter "cruiseId" was null or undefined when calling findGateways().'
            );
        }

        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling findGateways().'
            );
        }

        if (requestParameters['priceModelCode'] == null) {
            throw new runtime.RequiredError(
                'priceModelCode',
                'Required parameter "priceModelCode" was null or undefined when calling findGateways().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['agencyId'] != null) {
            queryParameters['agencyId'] = requestParameters['agencyId'];
        }

        if (requestParameters['priceModelCode'] != null) {
            queryParameters['priceModelCode'] = requestParameters['priceModelCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTrackingIdentifier'] != null) {
            headerParameters['X-Tracking-Identifier'] = String(requestParameters['xTrackingIdentifier']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/cruises/{cruiseId}/gateways`.replace(`{${"cruiseId"}}`, encodeURIComponent(String(requestParameters['cruiseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GatewayFromJSON));
    }

    /**
     * Retrieves available gateways for flex flights regarding given cruise
     */
    async findGateways(requestParameters: FindGatewaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Gateway>> {
        const response = await this.findGatewaysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves available rail transports regarding given cruise
     */
    async findRailTransportsRaw(requestParameters: FindRailTransportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RailTransport>>> {
        if (requestParameters['cruiseId'] == null) {
            throw new runtime.RequiredError(
                'cruiseId',
                'Required parameter "cruiseId" was null or undefined when calling findRailTransports().'
            );
        }

        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling findRailTransports().'
            );
        }

        if (requestParameters['priceModelCode'] == null) {
            throw new runtime.RequiredError(
                'priceModelCode',
                'Required parameter "priceModelCode" was null or undefined when calling findRailTransports().'
            );
        }

        if (requestParameters['ages'] == null) {
            throw new runtime.RequiredError(
                'ages',
                'Required parameter "ages" was null or undefined when calling findRailTransports().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling findRailTransports().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['agencyId'] != null) {
            queryParameters['agencyId'] = requestParameters['agencyId'];
        }

        if (requestParameters['priceModelCode'] != null) {
            queryParameters['priceModelCode'] = requestParameters['priceModelCode'];
        }

        if (requestParameters['ages'] != null) {
            queryParameters['ages'] = requestParameters['ages'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['gateway'] != null) {
            queryParameters['gateway'] = requestParameters['gateway'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTrackingIdentifier'] != null) {
            headerParameters['X-Tracking-Identifier'] = String(requestParameters['xTrackingIdentifier']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/cruises/{cruiseId}/railTransports`.replace(`{${"cruiseId"}}`, encodeURIComponent(String(requestParameters['cruiseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RailTransportFromJSON));
    }

    /**
     * Retrieves available rail transports regarding given cruise
     */
    async findRailTransports(requestParameters: FindRailTransportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RailTransport>> {
        const response = await this.findRailTransportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves specific cabin for given cruise
     */
    async getCabinRaw(requestParameters: GetCabinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cabin>> {
        if (requestParameters['cruiseId'] == null) {
            throw new runtime.RequiredError(
                'cruiseId',
                'Required parameter "cruiseId" was null or undefined when calling getCabin().'
            );
        }

        if (requestParameters['cabinNumber'] == null) {
            throw new runtime.RequiredError(
                'cabinNumber',
                'Required parameter "cabinNumber" was null or undefined when calling getCabin().'
            );
        }

        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling getCabin().'
            );
        }

        if (requestParameters['priceModelCode'] == null) {
            throw new runtime.RequiredError(
                'priceModelCode',
                'Required parameter "priceModelCode" was null or undefined when calling getCabin().'
            );
        }

        if (requestParameters['adults'] == null) {
            throw new runtime.RequiredError(
                'adults',
                'Required parameter "adults" was null or undefined when calling getCabin().'
            );
        }

        if (requestParameters['juveniles'] == null) {
            throw new runtime.RequiredError(
                'juveniles',
                'Required parameter "juveniles" was null or undefined when calling getCabin().'
            );
        }

        if (requestParameters['children'] == null) {
            throw new runtime.RequiredError(
                'children',
                'Required parameter "children" was null or undefined when calling getCabin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['agencyId'] != null) {
            queryParameters['agencyId'] = requestParameters['agencyId'];
        }

        if (requestParameters['priceModelCode'] != null) {
            queryParameters['priceModelCode'] = requestParameters['priceModelCode'];
        }

        if (requestParameters['adults'] != null) {
            queryParameters['adults'] = requestParameters['adults'];
        }

        if (requestParameters['juveniles'] != null) {
            queryParameters['juveniles'] = requestParameters['juveniles'];
        }

        if (requestParameters['children'] != null) {
            queryParameters['children'] = requestParameters['children'];
        }

        if (requestParameters['babies'] != null) {
            queryParameters['babies'] = requestParameters['babies'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTrackingIdentifier'] != null) {
            headerParameters['X-Tracking-Identifier'] = String(requestParameters['xTrackingIdentifier']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/cruises/{cruiseId}/cabins/{cabinNumber}`.replace(`{${"cruiseId"}}`, encodeURIComponent(String(requestParameters['cruiseId']))).replace(`{${"cabinNumber"}}`, encodeURIComponent(String(requestParameters['cabinNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CabinFromJSON(jsonValue));
    }

    /**
     * Retrieves specific cabin for given cruise
     */
    async getCabin(requestParameters: GetCabinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cabin> {
        const response = await this.getCabinRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves Informations regarding given cruise
     */
    async getCruiseRaw(requestParameters: GetCruiseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Cruise>> {
        if (requestParameters['cruiseId'] == null) {
            throw new runtime.RequiredError(
                'cruiseId',
                'Required parameter "cruiseId" was null or undefined when calling getCruise().'
            );
        }

        if (requestParameters['agencyId'] == null) {
            throw new runtime.RequiredError(
                'agencyId',
                'Required parameter "agencyId" was null or undefined when calling getCruise().'
            );
        }

        if (requestParameters['priceModelCode'] == null) {
            throw new runtime.RequiredError(
                'priceModelCode',
                'Required parameter "priceModelCode" was null or undefined when calling getCruise().'
            );
        }

        if (requestParameters['adults'] == null) {
            throw new runtime.RequiredError(
                'adults',
                'Required parameter "adults" was null or undefined when calling getCruise().'
            );
        }

        if (requestParameters['juveniles'] == null) {
            throw new runtime.RequiredError(
                'juveniles',
                'Required parameter "juveniles" was null or undefined when calling getCruise().'
            );
        }

        if (requestParameters['children'] == null) {
            throw new runtime.RequiredError(
                'children',
                'Required parameter "children" was null or undefined when calling getCruise().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['agencyId'] != null) {
            queryParameters['agencyId'] = requestParameters['agencyId'];
        }

        if (requestParameters['priceModelCode'] != null) {
            queryParameters['priceModelCode'] = requestParameters['priceModelCode'];
        }

        if (requestParameters['adults'] != null) {
            queryParameters['adults'] = requestParameters['adults'];
        }

        if (requestParameters['juveniles'] != null) {
            queryParameters['juveniles'] = requestParameters['juveniles'];
        }

        if (requestParameters['children'] != null) {
            queryParameters['children'] = requestParameters['children'];
        }

        if (requestParameters['babies'] != null) {
            queryParameters['babies'] = requestParameters['babies'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTrackingIdentifier'] != null) {
            headerParameters['X-Tracking-Identifier'] = String(requestParameters['xTrackingIdentifier']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = await this.configuration.apiKey("x-api-key"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/cruises/{cruiseId}`.replace(`{${"cruiseId"}}`, encodeURIComponent(String(requestParameters['cruiseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CruiseFromJSON(jsonValue));
    }

    /**
     * Retrieves Informations regarding given cruise
     */
    async getCruise(requestParameters: GetCruiseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Cruise> {
        const response = await this.getCruiseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
